export enum CouponFormFieldsNames {
  Coupon = 'coupon',
}
export interface CouponFormFields {
  [CouponFormFieldsNames.Coupon]: string;
}
